/**
 * @title UI helper
 * 
 * @author The Ciao Development Team
 */

// ---------------------------------------------------------------------------
// * UI - Modal dialog windows

export class Modal {
  constructor() {
    this.screen_el = null;
    this.content_el = null;
    this.key_handler = null;
  }

  get_elm() {
    return this.content_el;
  }

  // TODO: improve...
  /* force wide dialog */
  set_wide() {
    let m = this.content_el;
    m.style.maxWidth = "calc(100% - 64px)";
    m.style.width = "calc(100% - 64px)";
    m.style.maxHeight = "calc(100% - 32px - 96px)";
    m.style.height = "calc(100% - 32px - 96px)";
    m.style.padding = "0px";
  }

  /* (un)set visibility */
  set_visible(visibility) {
    function set_visible(elm, visible) {
      let d = visible ? 'block' : 'none';
      if (elm.style.display !== d) {
        elm.style.display = d;
      }
    }
    set_visible(this.screen_el, visibility);
    set_visible(this.content_el, visibility);
  }

  alloc(base_el) {
    let dp = elem_cn('div', 'modal-screen');
    dp.style.display = "none";
    this.screen_el = dp;
    let dpc = elem_cn('div', 'modal-content');
    dpc.style.display = "none";
    this.content_el = dpc;
    dp.appendChild(dpc);
    base_el.appendChild(dp);
  }

  remove() {
    if (!this.screen_el) return;
    this.content_el.remove();
    this.screen_el.remove();
    this.content_el = null;
    this.screen_el = null;
  }

  // Set visible, set key listener
  open() {
    this.set_visible(true);
    const key_handler = (e) => {
      if (e.keyCode == 27 || e.keyCode == 32 || e.keyCode == 13 || e.keyCode == 81) {
        this.close();
      }
    };
    this.key_handler = key_handler;
    const close_modal = () => {
      this.set_visible(false);
      this.remove();
      window.removeEventListener('keydown', this.key_handler);
    };
    window.addEventListener('keydown', this.key_handler);
  }

  // Set invisible and remove
  close() {
    this.set_visible(false);
    this.remove();
    window.removeEventListener('keydown', this.key_handler);
  }
}

// ---------------------------------------------------------------------------
// * UI - Helper for dropdowns

// Dropdown button with pg actions in the item list
// TODO: move to lpdoc.js?
export function btn_dropdown_act(pg, menu, title, btn_text_el, items) {
  let do_action = {};
  for (let x of items) { do_action[x.k] = x.a; }
  return new DropdownButton(menu, title, btn_text_el, items,
                            value => {
                              (async() => {
                                await do_action[value](pg);
                              })();
                            });
}

// ---------------------------------------------------------------------------
// * UI - Layouts for playground

// TODO: generalize
export var layout_modif_list = [
  { k:'E', n:'Editor' }, // Toggle editor
  { k:'T', n:'Toplevel' }, // Toggle toplevel
  { k:'P', n:'Preview (normal)' }, // Toggle preview
  { k:'Pt', n:'Preview (tall)' }, // Toggle preview (in tall mode)
  { k:'Pw', n:'Preview (wide)' } // Toggle preview (in wide mode)
];

export class Layout {
  static create(modifs) {
    let p = new Layout();
    for (const m of modifs) { p.toggle(m); }
    return p;
  }
  constructor() {
    this.e = false;
    this.t = false;
    this.p = false;
  }
  set(o) {
    this.e = o.e;
    this.t = o.t;
    this.p = o.p;
  }
  is_empty() {
    let c = 0;
    if (this.e !== false) c++;
    if (this.t !== false) c++;
    if (this.p !== false) c++;
    return c == 0;
  }
  // Toggle layout
  toggle(layout_modif) {
    let c = 0;
    let prev = new Layout();
    prev.set(this);
    switch(layout_modif) {
    case 'E': this.e = !this.e; break;
    case 'T': this.t = !this.t; break;
    case 'P': this.p = (this.p !== true ? true : false); break;
    case 'Pt': this.p = (this.p !== 'tall' ? 'tall' : false); break;
    case 'Pw': this.p = (this.p !== 'wide' ? 'wide' : false); break;
    }
    if (this.is_empty()) this.set(prev); // restore 
  }
  enabled_modif(layout_modif) {
    switch(layout_modif) {
    case 'E': return this.e === true;
    case 'T': return this.t === true;
    case 'P': return this.p === true;
    case 'Pt': return this.p === 'tall';
    case 'Pw': return this.p === 'wide';
    }
    return false;
  }
  // Get layout sequence (ls) array (see gen_layout)
  get_ls(narrow) {
    let ls = '';
    function upd_(ls, x, n) {
      if (ls=='') {
        if (x!==false) return n;
      } else if (Array.isArray(ls)) { // rebalance
        if (x===true) return [ls[0],ls[1],['v',ls[2],n]];
        if (x==='tall') return [ls[0],['v',ls[1],ls[2]],n];
        if (x==='wide') return ['v',ls,n];
      } else {
        if (x===true) return ['h',ls,n];
        if (x==='tall') return ['h',ls,n];
        if (x==='wide') return ['v',ls,n];
      }
      return ls;
    }
    ls = upd_(ls, this.e, 'E');
    ls = upd_(ls, this.t, 'T');
    ls = upd_(ls, this.p, 'P');
    if (narrow && Array.isArray(ls) && ls[0] == 'h') {
      ls[0] = 'v';
    }
    return ls;
  }
}

// ---------------------------------------------------------------------------
// * Visibility state

/** Use this class to keep track a set of attributes and their values,
  and trigger actions when these attributes changes. */
export class Vis {
  #ref;
  #curr;
  constructor() {
    this.#ref = {};
    this.#curr = {};
  }
  // Execute f(ref[name]) when ref[name] is being updated (w.r.t. curr[name])
  inc_update(name, f) {
    // (store value with JSON.stringify to compare elements) // TODO: better way?
    let str = JSON.stringify(this.#ref[name]);
    if (this.#curr[name] !== str) {
      this.#curr[name] = str;
      f(this.#ref[name]);
    }
  }
  // Force an update of curr[name] 
  force_update(name) {
    this.#curr[name] = null;
  }
  get(name) {
    return this.#ref[name];
  }
  set(name, v) {
    this.#ref[name] = v;
  }
}

// Local Variables:
// eval: (outshine-mode)
// End:
